import fetch from 'utils/fetch';

export function loginByAccount(account, password) {
    const data = {
        account,
        password
    };
    return fetch({
        url: '/login',
        method: 'post',
        data
    });
}

export function logout() {
    return fetch({
        url: '/login/logout',
        method: 'post'
    });
}

export function getInfo(uid) {
    return fetch({
        url: '/user/info',
        method: 'get',
        params: {uid}
    });
}
export function checkLogin() {
    return fetch({
        url: '/login/check',
        method: 'get'
    });
}
export function queryPermission(account) {
    const data = {
        account
    };
    return fetch({
        url: '/queryPermission',
        method: 'get',
        params : data
    });
}
export function changePassword(params) {
    return fetch({
        url: '/user/changePassword',
        method: 'post',
        params 
    });
}





// WEBPACK FOOTER //
// ./src/api/login.js